module.exports = __webpack_public_path__ + "img/15.7.Chla.1a607b2d.png";